/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import Button from '../../../../components/general/button';
import Chevron from '../../../../components/general/navigation-chevron';

const ActionsWrapper = styled.div`
	max-width: ${({disabled}) => disabled ? '310px' : '50%'};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding-left: ${({disabled}) => disabled ? '39px' : '48%'};
	align-items: ${({disabled}) => disabled ? 'center' : 'flex-start'};
	opacity: ${({disabled}) => disabled ? '.5' : '1'};
`;

const ActionNotice = styled.p`
	max-width: 140px;
	font-size: 14px;
	font-weight: 600;
	color: #686871;
	text-align: ${({disabled}) => disabled ? 'center' : 'left'};
	margin-bottom: 27px;
`;

const ActionsButtonsWrapper = styled.div`
	display: flex;
	flex-direction: ${({disabled}) => disabled ? 'column' : 'row'};

	& > button + button {
		margin: ${({disabled}) => disabled ? '10px 0 0' : '0 0 0 25px'};
	}
`;

const ActionButton = styled(Button)`
	display: flex;
	align-items: center;
	justify-content: center;

	width: 176px;
	font-size: 14px;
	border-width: 2px;
	background: ${({disabled}) => disabled ? 'transparent' : '#fff'};

	${({disabled, dark}) =>
    disabled || dark
        ? `
				color: #686871;
				border-color: #686871;

				& span {
					border-color: #686871;
				}
			`
        : ''
    };

	${({disabled, dark}) => disabled
    ? `
			&:hover {
				background: transparent;
				color: #686871;
			}
		`
    : dark
        ? `
				&:hover {
					background: #686871;
				}
			`
        : ''
    }
`;

const Actions = ({
                     disabled = false,
                     reserve,
                     submit,
                 }) => (
    <ActionsWrapper disabled={disabled}>
        <ActionNotice disabled={disabled}>
            Arbeitsplatz/Ticket reservieren?
        </ActionNotice>

        <ActionsButtonsWrapper disabled={disabled}>
            <ActionButton
                disabled={disabled}
                dark
                onClick={disabled ? null : () => reserve()}
            >
                Reservieren

                <Chevron/>
            </ActionButton>

            <ActionButton
                disabled={disabled}
                onClick={disabled ? null : submit}
            >
                Auftrag ausführen

                <Chevron/>
            </ActionButton>
        </ActionsButtonsWrapper>
    </ActionsWrapper>
);

export default Actions;



// WEBPACK FOOTER //
// ./src/components/task/shop/form/actions.js